import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Building2, ChevronRight, Users } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const stripHtml = (html) => {
  if (!html) return '';
  if (typeof document === 'undefined') return html.replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim();
  const tmp = document.createElement('div');
  tmp.innerHTML = html;
  return (tmp.textContent || tmp.innerText || '').replace(/\s+/g, ' ').trim();
};

export default function Derneklerimiz() {
  const [associations, setAssociations] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${BACKEND_URL}/api/associations`)
      .then(r => r.json())
      .then(data => { setAssociations(Array.isArray(data) ? data : []); setLoading(false); })
      .catch(() => setLoading(false));
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-amber-50">
        <div className="text-amber-700 text-lg animate-pulse">Yükleniyor...</div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-b from-amber-50 to-white py-12">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-br from-amber-500 to-orange-500 rounded-2xl mb-4 shadow-lg">
            <Building2 className="w-8 h-8 text-white" />
          </div>
          <h1 className="text-4xl sm:text-5xl font-bold text-amber-900 mb-4" style={{ fontFamily: 'Merriweather, serif' }}>
            Derneklerimiz
          </h1>
          <p className="text-lg text-amber-700 max-w-2xl mx-auto">
            Kızılören'de faaliyet gösteren dernekleri keşfedin
          </p>
        </div>

        {associations.length === 0 ? (
          <div className="text-center py-16 text-amber-600">
            <Building2 className="w-16 h-16 mx-auto mb-4 opacity-30" />
            <p className="text-xl">Henüz dernek bilgisi eklenmemiş.</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {associations.map(assoc => (
              <Link
                key={assoc.id}
                to={`/derneklerimiz/${assoc.slug}`}
                className="group block"
                data-testid={`association-card-${assoc.slug}`}
              >
                <div className="bg-white rounded-2xl shadow-md border border-amber-100 overflow-hidden hover:shadow-xl hover:border-amber-300 transition-all duration-300 transform hover:-translate-y-1">
                  {assoc.image_url ? (
                    <div className="h-48 overflow-hidden">
                      <img src={assoc.image_url} alt={assoc.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300" />
                    </div>
                  ) : (
                    <div className="h-48 bg-gradient-to-br from-amber-400 to-orange-500 flex items-center justify-center">
                      <Building2 className="w-16 h-16 text-white opacity-70" />
                    </div>
                  )}
                  <div className="p-6">
                    <h3 className="text-xl font-bold text-amber-900 mb-2 group-hover:text-orange-600 transition-colors">
                      {assoc.name}
                    </h3>
                    <p className="text-amber-700 text-sm mb-3 line-clamp-3">
                      {stripHtml(assoc.about)}
                    </p>
                    <div className="flex items-center justify-between">
                      <div className="flex items-center gap-2 text-amber-600 text-sm">
                        <Users className="w-4 h-4" />
                        <span>{assoc.president_name}</span>
                      </div>
                      <ChevronRight className="w-5 h-5 text-amber-400 group-hover:text-orange-500 transition-colors" />
                    </div>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
